import { createRoot } from "react-dom/client";

/**
 * Mounts the SPA at the document root so React can render the complete html/head/body tree.
 * React DOM supports Document containers at runtime, but its public Container type omits Document.
 */
export function createDocumentRoot(target: Document): ReturnType<typeof createRoot> {
  return createRoot(target as unknown as Parameters<typeof createRoot>[0]);
}
